/* =====================================================================
 * storageFileActions — 파일 저장소 컨텍스트 메뉴에 기능 모듈이 액션을 꽂는 DI 슬롯
 *
 * `specializedAgentPanelSlot` 과 같은 이유로 DI 다: shared 패키지는 호스트 전용
 * 기능(구매 에이전트 등)을 import 할 수 없다. 호스트가 bootstrap 때
 * `registerStorageFileAction(...)` 으로 등록하면 StoragePage 가 파일 한 건의
 * 컨텍스트 메뉴 끝에 그 액션을 붙인다 (applies 가 true 인 파일에만).
 *
 * 용례: "구매 에이전트로 분석" — 저장소에 직접 올린 선적서류 번들을 업로드 없이
 * 구매 화면으로 넘긴다. 시작 화면의 저장소 목록을 없앤 자리(파일 저장소가 정본).
 * ===================================================================== */

import type React from 'react';
import type { WorkspaceFile } from '@auw/workspace-utils';

export interface StorageFileActionHelpers {
  /** 라우트 이동 — StoragePage 의 navigate. 액션은 모드 경로만 넘긴다. */
  navigate: (path: string) => void;
}

export interface StorageFileAction {
  /** 메뉴 항목 id (등록 모듈 접두 권장: `purchase-agent:analyze`). 같은 id 재등록은 교체. */
  id: string;
  label: string;
  icon?: React.ReactNode;
  /** 이 파일에 보일지. 파일 1건 메뉴에서만 평가된다 (다중 선택엔 안 붙는다). */
  applies: (file: WorkspaceFile) => boolean;
  run: (file: WorkspaceFile, helpers: StorageFileActionHelpers) => void;
}

const _actions = new Map<string, StorageFileAction>();

export function registerStorageFileAction(action: StorageFileAction): void {
  _actions.set(action.id, action);
}

export function unregisterStorageFileAction(id: string): void {
  _actions.delete(id);
}

export function listStorageFileActions(file: WorkspaceFile): StorageFileAction[] {
  const out: StorageFileAction[] = [];
  for (const action of _actions.values()) {
    let ok = false;
    try { ok = action.applies(file); } catch { ok = false; }
    if (ok) out.push(action);
  }
  return out;
}
